module.exports = __webpack_public_path__ + "img/20190625162140QQ截图20190624162700.4d6e7df2.png";